import { useEffect } from 'react';
import FrontendExceptionReporterService from 'modules/base/error/FrontendExceptionReporterService';
// import { logErrorToServer } from './logError';

// eslint-disable-next-line import/prefer-default-export
export function RootErrorHandler() {
    useEffect(() => {
        const onError = (event) => {
            console.log('Error');

            const errorData = {
                type: 'error',
                message: event.message,
                source: event.filename,
                lineno: event.lineno,
                colno: event.colno,
                stack: event.error?.stack || String(event.error),
            };
            FrontendExceptionReporterService.report('Error', null, JSON.stringify(errorData)).then(resp => console.log('Report sent.'));
        };

        const onUnhandledRejection = (event) => {
            console.log('Unhandled Rejection');

            const reason = event.reason;
            const message = reason?.message || String(reason);
            const stack = reason?.stack || null;

            const payload = { type: 'unhandledrejection', message, stack, };

            FrontendExceptionReporterService.report('Unhandled Rejection', null, JSON.stringify(payload)).then(resp => console.log('Report sent.'));
        };

        window.addEventListener('error', onError);
        window.addEventListener('unhandledrejection', onUnhandledRejection);

        return () => {
            window.removeEventListener('error', onError);
            window.removeEventListener('unhandledrejection', onUnhandledRejection);
        };
    }, []);

    return null;
}